/**
 * Created by Andrey Popov on 09.02.21.
 */

const FakeMerge = function (levelContent) {
    Map2dLocation.currentLocation = this;

    this.counter = {
        isActive: function () {
            return true; 
        },
        registerStage: function () {},
        trigger: function () {},
        setTimeout: function () {}
    };

    this.levelContent = levelContent;

    Object.assign(this, {
        location: {},
        tutorial: {
            isActive: function () {}
        },
        orders: {
            updateOrder: function () {},
            findCanCook: function () {
                return true;
            }
        },
        harvested: {
            canTakeList: function () {},
            on: function () {}
        },
        workers: {
            regular: [],
            findAssigned: function () {},
            countRegularFree: function () {
                return 2; 
            },
            countRegularTotal: function () {
                return 2; 
            },
            isBonusWorkerBuyed: function () {
                return false; 
            },
            removeInstant: function () {}
        },
        energyLottery: {
            isAvailable: function () {
                return false; 
            },
            isReady: function () {
                return false; 
            }
        },
        pushes: {
            updateFruits: function () {}
        },
        spawn: function () {
            return [];
        },
        storeSave: function () {
        },
        on: function () {
        },
        thirdElementPlanner: {
            thirdElements: []
        },
        needToReplaceWithCoins: function () {
        },
        customers: {
            removeCustomer: function () {}
        },
        friendPixelsPlanner: {
            isAvailable: function () {}
        }
    });
};

FakeMerge.prototype.stop = function () {
    if (this.stopped) {
        return;
    }
    this.stopped = true;

    InfoView.Clear();

    this.map && this.map.stop();
};

FakeMerge.prototype.on = function () {

};